import { render } from "./indexMobilePage.vue?vue&type=template&id=589d8b49&scoped=true"
import script from "./indexMobilePage.vue?vue&type=script&lang=js"
export * from "./indexMobilePage.vue?vue&type=script&lang=js"

import "./indexMobilePage.vue?vue&type=style&index=0&id=589d8b49&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.38_vue@3.4.38_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589d8b49"]])

export default __exports__